module.exports = __webpack_public_path__ + "static/small-hammock-dude-ba2fee3338c3bd27ce919426e838c36f.png";